function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import TableHeader from './TableHeader.react';
import TableRow from './TableRow.react';
var Table = function Table(_ref) {
  var _ref$data = _ref.data,
    data = _ref$data === void 0 ? [] : _ref$data,
    actions = _ref.actions,
    _ref$columns = _ref.columns,
    columns = _ref$columns === void 0 ? {} : _ref$columns,
    _ref$sort = _ref.sort,
    sort = _ref$sort === void 0 ? null : _ref$sort,
    _ref$tr = _ref.tr,
    tr = _ref$tr === void 0 ? {} : _ref$tr,
    _ref$filter = _ref.filter,
    filter = _ref$filter === void 0 ? '' : _ref$filter,
    _ref$filterColumns = _ref.filterColumns,
    filterColumns = _ref$filterColumns === void 0 ? [] : _ref$filterColumns;
  var _useState = useState({
      rows: [],
      layout: [],
      sort: null,
      tr: {}
    }),
    _useState2 = _slicedToArray(_useState, 2),
    table = _useState2[0],
    setTable = _useState2[1];
  useEffect(function () {
    setTable(_objectSpread(_objectSpread({}, table), {}, {
      tr: _objectSpread(_objectSpread({}, table.tr), tr),
      // TODO :: do we even need this? or can we just set rows: data
      // TODO :: escape null values here to make sort work
      rows: !Array.isArray(data) ? Object.values(data).map(function (x) {
        return x;
      }) : data,
      layout: Object.keys(columns).map(function (x) {
        var _columns$x = columns[x],
          _columns$x$title = _columns$x.title,
          title = _columns$x$title === void 0 ? null : _columns$x$title,
          _columns$x$onClick = _columns$x.onClick,
          onClick = _columns$x$onClick === void 0 ? null : _columns$x$onClick,
          _columns$x$type = _columns$x.type,
          type = _columns$x$type === void 0 ? null : _columns$x$type,
          _columns$x$render = _columns$x.render,
          render = _columns$x$render === void 0 ? null : _columns$x$render,
          _columns$x$format = _columns$x.format,
          format = _columns$x$format === void 0 ? null : _columns$x$format,
          _columns$x$th = _columns$x.th,
          th = _columns$x$th === void 0 ? {} : _columns$x$th,
          _columns$x$td = _columns$x.td,
          td = _columns$x$td === void 0 ? {} : _columns$x$td,
          _columns$x$sort = _columns$x.sort,
          sort = _columns$x$sort === void 0 ? {} : _columns$x$sort,
          _columns$x$visible = _columns$x.visible,
          visible = _columns$x$visible === void 0 ? true : _columns$x$visible,
          _columns$x$size = _columns$x.size,
          size = _columns$x$size === void 0 ? null : _columns$x$size;
        return {
          key: x['key'] || x,
          title: title || columns[x],
          onClick: onClick,
          type: type,
          sort: sort,
          render: render,
          format: format,
          th: th,
          td: td,
          visible: visible,
          size: size
        };
      }),
      sort: !table.sort && (sort || Object.keys(columns).length > 0) ? sort || {
        by: Object.keys(columns)[0],
        asc: true
      } : table.sort
    }));
  }, [data]);

  // https://www.sitepoint.com/sort-an-array-of-objects-in-javascript/
  // NOTE :: make copy or affect the default object?
  var rows = _toConsumableArray(table.rows);

  // TODO :: check for lowercase/uppercase etc...
  // TODO :: handle bool/int/flt/date
  if (table.sort) {
    var _table$sort;
    rows = rows.sort(function (a, b) {
      if (typeof a[table.sort.by] === 'string' || a[table.sort.by] instanceof String) return a[table.sort.by].localeCompare(b[table.sort.by]);else if (typeof a[table.sort.by] === 'number') return a[table.sort.by] - b[table.sort.by];
      return a;
    });
    if (((_table$sort = table.sort) === null || _table$sort === void 0 ? void 0 : _table$sort.asc) === false) rows.reverse();
  }
  var handleSelectRow = function handleSelectRow(row) {
    setTable(_objectSpread(_objectSpread({}, table), {}, {
      rows: table.rows.map(function (x) {
        if (x.id === row.id) x.isSelected = 'isSelected' in x ? !x.isSelected : true;
        return x;
      })
    }));
  };
  filter = filter.toLowerCase();
  if (filter.length > 0 && filterColumns.length > 0) {
    rows = rows.filter(function (x) {
      for (var i = 0; i < filterColumns.length; i++) {
        var _x$filterColumns$i;
        console.log('x[filterColumns[i]]', x[filterColumns[i]]);
        if ((_x$filterColumns$i = x[filterColumns[i]]) !== null && _x$filterColumns$i !== void 0 && _x$filterColumns$i.toString().toLowerCase().includes(filter)) return x;
      }
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "table"
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement(TableHeader, {
    table: table,
    actions: actions,
    onSort: function onSort(key) {
      var _table$sort2, _table$sort3;
      setTable(_objectSpread(_objectSpread({}, table), {}, {
        sort: {
          by: key,
          asc: ((_table$sort2 = table.sort) === null || _table$sort2 === void 0 ? void 0 : _table$sort2.by) === key ? !((_table$sort3 = table.sort) !== null && _table$sort3 !== void 0 && _table$sort3.asc) : true
        }
      }));
    }
  }), /*#__PURE__*/React.createElement("tbody", null, rows.map(function (x) {
    return /*#__PURE__*/React.createElement(TableRow, {
      actions: actions,
      row: x,
      table: table,
      onSelect: handleSelectRow,
      key: x.id
    });
  }))));
};
export default Table;